import { makeStyles } from '@material-ui/styles'
import FontAwesomeIcon from 'core/components/FontAwesomeIcon'
import Text from 'core/elements/Text'
import Theme from 'core/themes/model'
import { ReactNode } from 'react'

const useStyles = makeStyles<Theme>((theme) => ({
  errorMessage: {
    display: 'grid',
    gridTemplateColumns: '26px auto',
    alignItems: 'center',
  },
  errorText: {
    color: theme.components.graph.error,
  },
}))

export const ErrorText = ({ children }: { children: ReactNode }) => {
  const classes = useStyles({})

  return (
    <div className={classes.errorMessage}>
      <FontAwesomeIcon>circle-exclamation</FontAwesomeIcon>
      <Text variant="body1" className={classes.errorText}>
        {children}
      </Text>
    </div>
  )
}
